/* global Parse */

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import Client from './Client';

Client.getdburi().then(response => {
  console.log(response); // eslint-disable-line no-console

  Parse.initialize(response.appId, response.javascriptKey);
  Parse.serverURL = response.apiAddress;
  
  const container = document.getElementById('root');
  const root = createRoot(container);
  root.render(<App />);
}).catch(err => {
  console.error(err); // eslint-disable-line no-console
});
